import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    AirspaceAuthorisationDto,
    AirspaceAuthorisationService,
    FlyFreelyConstants,
    FlyFreelyError,
    SessionExpired,
    parseErrorBody
} from '@flyfreely-portal-ui/flyfreely';
import {
    Subject,
    catchError,
    switchMap,
    takeUntil,
    throwError,
    timer
} from 'rxjs';

@Injectable()
export class AccountAirspaceDataService {
    private baseUrl: string;

    private externalAuthorisationBearerToken: string;

    private http: HttpClient;
    private stopPollingAuthorisation$ = new Subject<void>();
    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private constants: FlyFreelyConstants,
        private airspaceAuthorisationService: AirspaceAuthorisationService,
        private httpHandler: HttpBackend
    ) {
        this.http = new HttpClient(httpHandler);
        // this.baseUrl = this.constants.API_URL;
        this.startPollingAuthenticationBearerToken();
        this.baseUrl = this.constants.API_URL;
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
        this.stopPollingAuthorisation$.next();
        this.stopPollingAuthorisation$.complete();
    }

    private startPollingAuthenticationBearerToken() {
        // attempt tp refresh the bearer token every 30 minutes
        timer(0, 1800000)
            .pipe(
                switchMap(() => this.getAuthenticationBearerToken()),
                takeUntil(this.stopPollingAuthorisation$)
            )
            .subscribe({
                next: token =>
                    (this.externalAuthorisationBearerToken = token.accessToken),
                error: (error: FlyFreelyError) => {
                    this.stopPollingAuthorisation$.next();
                    this.externalAuthorisationBearerToken = null;
                }
            });
    }

    private getAuthenticationBearerToken() {
        return this.airspaceAuthorisationService.getAlternativeExternalAuthorisationToken();
    }

    downloadAllUsersAuthorisations(
        checkerUrl: string,
        authorisationType: AirspaceAuthorisationDto.AuthorisationType
    ) {
        if (this.externalAuthorisationBearerToken == null) {
            // If there's no bearer token, restart the polling and throw an error
            this.stopPollingAuthorisation$.next();
            this.startPollingAuthenticationBearerToken();
            return throwError(() => new SessionExpired());
        }
        const headers = new HttpHeaders().set(
            'Authorization',
            `Bearer ${this.externalAuthorisationBearerToken}`
        );
        return this.http
            .get(
                `${checkerUrl}/authorisations/${authorisationType}/authorisations`,
                {
                    headers: headers,
                    responseType: 'blob'
                }
            )
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return throwError(() => parseErrorBody(err));
                })
            );
    }
}
